export const ISSUE_STATE_ACTIVE = 'ACTIVE';
export const ISSUE_STATE_IN_PROGRESS = 'IN_PROGRESS';
export const ISSUE_STATE_DONE = 'DONE';
